import util from "./_util";
import gcgl from "./gcgl";
import htgl from "./htgl";  
import dwgl from "./dwgl";
import zzjg from "./zzjg";
import wtgl from "./wtgl";
import skbh from "./skbh";
import login from "./login"; //租户管理登录
import sysLogin from "./sysLogin"; //系统管理登录
import systenant from "./Systenant"; //租户管理接口 
import getuserinfo from "./getuserinfo";

export default {
  ...util,
  ...htgl,
  ...gcgl,  
  ...dwgl,
  ...zzjg,
  ...wtgl,
  ...skbh,
  ...login,
  ...getuserinfo,
  ...sysLogin,
  ...systenant, 
};
